import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const modules = [
  { key: 'module.review.title', descKey: 'module.review.desc', icon: 'ri-star-line', slug: 'usfans-spreadsheet-guide' },
  { key: 'module.shipping.title', descKey: 'module.shipping.desc', icon: 'ri-truck-line', slug: 'usfans-shipping-cost' },
  { key: 'module.coupon.title', descKey: 'module.coupon.desc', icon: 'ri-coupon-3-line', slug: 'usfans-coupon' },
  { key: 'module.warehouse.title', descKey: 'module.warehouse.desc', icon: 'ri-archive-line', slug: 'usfans-warehouse' },
  { key: 'module.safety.title', descKey: 'module.safety.desc', icon: 'ri-shield-check-line', slug: 'is-usfans-legit' },
];

export default function GuidesSection() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-7xl">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950">{t('guides.title')}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{t('guides.subtitle')}</p>
        </div>

        {/* Featured guide */}
        <Link
          to="/guides/usfans-spreadsheet-guide"
          className="group mt-10 grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
        >
          <div className="relative w-full h-56 md:h-72 lg:h-auto overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20neat%20desk%20with%20printed%20spreadsheet%20pages%2C%20a%20tablet%20showing%20a%20product%20grid%2C%20a%20pen%20and%20a%20small%20potted%20plant%2C%20warm%20morning%20light%2C%20soft%20cream%20and%20sage%20green%20tones%2C%20minimalist%20editorial%20composition%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark&width=1200&height=675&seq=article-guide-01&orientation=landscape&nocache=true"
              alt="USFans Spreadsheet complete guide"
              title="USFans Spreadsheet complete guide"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="p-6 md:p-8 flex flex-col justify-center">
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold whitespace-nowrap w-fit">
              <i className="ri-fire-line text-sm mr-1" />
              Complete Guide
            </span>
            <h3 className="mt-3 text-xl md:text-2xl font-heading font-semibold text-foreground-950">
              USFans Spreadsheet: Complete Guide to Finding & Comparing Resources
            </h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              Learn what a USFans spreadsheet is, how it is organized, and how to use it for product research, shipping, warehouse and safety — with a practical checklist.
            </p>
            <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
              {t('guides.readMore')}
              <i className="ri-arrow-right-line text-base group-hover:translate-x-1 transition-transform" />
            </span>
          </div>
        </Link>

        {/* Module cards */}
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {modules.map((m) => (
            <Link
              key={m.key}
              to={`/guides/${m.slug}`}
              className="group p-5 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={`${m.icon} text-xl`} />
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{t(m.key)}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{t(m.descKey)}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-primary-600">
                {t('guides.readMore')}
                <i className="ri-arrow-right-line text-base group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}